import {
  Spacing,
  Text,
  Modal,
  Button,
  pxToRem,
  palette,
  media,
  boxShadow,
} from "@ottatech/design";
import styled from "styled-components";

const StyledModal = styled(Modal)<{ src: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${palette.grayscale.shade400};
  background-image: url(${({ src }) => src});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: ${pxToRem(900)} ${pxToRem(850)};
  background-position-y: -${pxToRem(200)};

  box-shadow: ${boxShadow};

  max-width: ${pxToRem(580)};
  min-height: ${pxToRem(308)};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;

  border-radius: ${pxToRem(12)};
  background-color: white;

  margin: ${pxToRem(48)} ${pxToRem(16)};
  padding: ${pxToRem(16)} ${pxToRem(24)};
  height: ${pxToRem(263)};

  bottom: -${pxToRem(8)};

  ${media({ from: "tablet" })`
        margin: ${pxToRem(48)};
        padding: ${pxToRem(24)} ${pxToRem(40)};
         height: ${pxToRem(212)};
    `}
`;

interface RolloutModalProps {
  handleClose: () => void;
}

export function RolloutModal({
  handleClose,
}: RolloutModalProps): React.ReactElement | null {
  const gifUrl =
    "https://static.otta.com/videos/invest-in-yourself-colourway-2-compressed.gif";

  return (
    <StyledModal onClose={handleClose} dismissable={false} src={gifUrl}>
      <Container>
        <Spacing>
          <Text align="center" size={2} bold>
            Job searching just levelled up
          </Text>
          <Text align="center">
            We moved key info to the top of the page to make it easier to view
            jobs at a glance!
          </Text>
          <Button level="primary" onClick={handleClose}>
            Check it out now
          </Button>
        </Spacing>
      </Container>
    </StyledModal>
  );
}
